import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4;
import { fontSize, lineHeight } from "../../constants/typography";
import { BORDER_RADIUS } from "../../constants/borders";
import mediaQueries from "../../util/mediaqueries";
import styled from 'styled-components';
import { StyledContainer as Container } from "./base.styles";
export var StyledContainer = styled(Container).withConfig({
  componentId: "sc-1ljanvp-0"
})([""]);
export var StyledMessageContainer = styled.div.withConfig({
  componentId: "sc-1ljanvp-1"
})(["display:flex;align-items:center;flex-grow:1;gap:16px;", ""], mediaQueries.md(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    justify-content: center;\n    align-items: unset;\n    gap: unset;\n  "]))))));
export var StyledMessage = styled.p.withConfig({
  componentId: "sc-1ljanvp-2"
})(["display:inline-block;flex-grow:1;margin:0;", ""], mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: inline;\n    flex-grow: unset;\n  "]))))));
export var StyledCtaPrimaryLink = styled.a.withConfig({
  componentId: "sc-1ljanvp-3"
})(["background-color:", ";border-color:", ";border-radius:", ";border-style:solid;border-width:1px;color:", ";display:inline-block;text-align:center;align-self:center;margin:-8px 8px;padding:3px 10px;font-size:", ";line-height:", ";white-space:nowrap;", " ", ""], function (_ref) {
  var $backgroundColor = _ref.$backgroundColor;
  return $backgroundColor;
}, function (_ref2) {
  var $color = _ref2.$color;
  return $color;
}, BORDER_RADIUS.small, function (_ref3) {
  var $color = _ref3.$color;
  return $color;
}, fontSize.x2Small, lineHeight.large, mediaQueries.sm(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-right: 0;\n    margin-left: 0;\n    padding: 8px 16px;\n    font-size: ", ";\n  "])), 0)), fontSize.small), mediaQueries.md(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    margin-right: 16px;\n    margin-left: 16px;\n  "]))))));